<div class="edit-recording-dialog-container">
	<div class="d-flex justify-content-between align-items-center">
		<span class="title" mat-dialog-title>{{ 'RECORDINGS.EDIT_DIALOG.TITLE' | translate }}</span>
		<button mat-icon-button (click)="cancel()" [disabled]="saving" class="d-flex justify-content-center align-items-center me-4">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<mat-dialog-content class="m-0 p-3">
		<form [formGroup]="form" (ngSubmit)="submit()">
			<div class="row">
				<mat-form-field class="w-100 pb-2">
					<mat-label>{{ 'RECORDINGS.MEDIUM' | translate }}</mat-label>
					<mat-select formControlName="mediumId">
						@for (medium of mediums; track medium.id) {
						<mat-option [value]="medium.id">{{ medium.name }}</mat-option>
						}
					</mat-select>
				</mat-form-field>
			</div>

			<div class="row date-time-row">
				<mat-form-field class="date-field pe-1">
					<mat-label>{{ 'RECORDINGS.UPLOAD.SCHEDULED_DATE' | translate }}</mat-label>
					<input matInput [matDatepicker]="scheduledDatePicker" formControlName="scheduledDate" />
					<mat-datepicker-toggle matIconSuffix [for]="scheduledDatePicker"></mat-datepicker-toggle>
					<mat-datepicker #scheduledDatePicker></mat-datepicker>
				</mat-form-field>

				<app-time-field class="time-field" [label]="'RECORDINGS.EDIT_DIALOG.START_TIME' | translate" formControlName="startTime"></app-time-field>
			</div>

			@if (errorMessage) {
			<div class="row pb-2">
				<span class="error-message">{{ errorMessage }}</span>
			</div>
			}
		</form>
	</mat-dialog-content>

	<mat-dialog-actions [align]="'end'" class="pe-4">
		<mat-divider class="w-100 my-2"></mat-divider>
		<div class="gap-2 d-flex justify-content-end pt-0">
			<button mat-flat-button type="button" color="primary" (click)="submit()" [disabled]="form.invalid || saving">
				{{ 'BUTTON.SAVE' | translate }}
			</button>
			<button mat-stroked-button type="button" (click)="cancel()" [disabled]="saving">
				{{ 'BUTTON.CANCEL' | translate }}
			</button>
		</div>
	</mat-dialog-actions>
</div>
